(function () {
  const forms = document.querySelectorAll('.stn-b2b-form');
  forms.forEach(function (form) {
    form.addEventListener('submit', function () {
      window.dataLayer = window.dataLayer || [];
      const quantity = form.querySelector('[name="contact[quantity_range]"]');
      const project = form.querySelector('[name="contact[project_type]"]');
      window.dataLayer.push({
        event: 'generate_lead',
        lead_type: 'rfq',
        quantity_range: quantity ? quantity.value : '',
        project_type: project ? project.value : '',
        page_location: window.location.href
      });
    });
  });
})();
